export default __webpack_public_path__ + "static/Logo_ATDE-09-080b2bbd091585fc580118826e3c5f97.png";